import React, { ReactElement, useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Modal61 from '@Common/Modal/Modal61';
import { Modal61Ref } from '@Types/common';
import { LocationTaskFile } from './Types';
import './ImageGalleryModal.scss';

interface ConfigModalProps {
    modalRef: React.RefObject<Modal61Ref> | null;
    files: Array<LocationTaskFile> | undefined;
    initialIndex: number;
}

const ImageGalleryModal = (props: ConfigModalProps): ReactElement => {

    const [activeIndex, setActiveIndex] = useState<number>(props.initialIndex);

    useEffect(() => {
        setActiveIndex(props.initialIndex);
    }, [props.initialIndex]);

    const onImageChange = (selectedIndex: number) => {
        setActiveIndex(selectedIndex);
    }

    return (
        <Modal61
            title='Image Gallery'
            ref={props.modalRef}
            isCentered={true}
            size='lg'
            customClassName='image-gallery-modal'
            body={
                <Carousel
                    interval={null}
                    prevIcon={<i className="far fa-chevron-left"></i>}
                    nextIcon={<i className="far fa-chevron-right"></i>}
                    activeIndex={activeIndex}
                    onSelect={onImageChange}
                >
                    {props.files?.map(f => (
                        <Carousel.Item key={f.id}>
                            <img src={f.imageObjectURL} alt={f.name} />
                        </Carousel.Item>
                    ))}

                </Carousel>
            }
            customFooter={<></>}
        />
    );
};

export default ImageGalleryModal;
